import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';
import { toast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HeroSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDownloadCV = () => {
    // Direct download approach - let browser handle it natively
    const downloadUrl = `${API}/cv/download?format=pdf`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Zane Powles MBE</h1>
          <p className="hero-subtitle">Strategic School Leader | Principal | SEND & Inclusion Expert | International Educator</p>
          <p className="hero-description">
            Proven educational leader with a distinguished track record driving whole-school improvement across three continents. From military service to MBE recognition, I bring strategic vision, operational excellence, and unwavering commitment to building inclusive, high-performing learning communities. Experienced in multi-site leadership, safeguarding, budget management, and transforming educational outcomes for all learners.
          </p>
          <div className="hero-buttons">
            <Button 
              onClick={() => scrollToSection('leadership-philosophy')} 
              className="btn-primary"
            >
              Leadership Philosophy
            </Button>
            <Button 
              onClick={handleDownloadCV} 
              variant="outline" 
              className="btn-secondary"
            >
              Download CV
            </Button>
          </div>
        </div>
      </div>
      <div className="scroll-indicator" onClick={() => scrollToSection('leadership-philosophy')}>
        <ArrowDown size={32} />
      </div>
    </section>
  );
};

export default HeroSection;